export default __webpack_public_path__ + "static/media/guasasapo.9405dc3c.png";